import _ from 'lodash';

import Combinatorics from 'js-combinatorics';

import {
  doesItemDrop,
  slotMap,
  getWeaponHands,
  canRollSocket,
  socketBonuses,
} from 'shared/items';
import { getSpecInfo } from 'shared/character';

import GameData from 'shared/gameData';

let loaded = false;

let Instances;
let Encounters;
let EncounterItems;


const loadStaticData = data => {
  if (!loaded) {
    EncounterItems = data.EncounterItems;
    Instances = data.Instances;

    Encounters = _.flatten(_.map(Instances, 'encounters'));
    loaded = true;
  }
};

const WARFORGED_BONUS_ID = 4783;
const TITANFORGED_BONUS_ID = 4784;

const mythicPlusItemFilter = () => true;

export const DIFFICULTIES = [{
  id: 'raid-lfr',
  type: 'raid',
  name: 'Raid Finder',
  bonusIds: [
    4825, // Raid Finder
    4786, // epic
  ],
}, {
  id: 'raid-normal',
  type: 'raid',
  name: 'Normal',
  bonusIds: [
    4822, // Normal (doesn't actually do anything)
    4786, // epic
  ],
}, {
  id: 'raid-heroic',
  type: 'raid',
  name: 'Heroic',
  bonusIds: [
    4799, // Heroic
    4786, // epic
  ],
}, {
  id: 'raid-mythic',
  type: 'raid',
  name: 'Mythic',
  bonusIds: [
    4800, // Mythic
    4786, // epic
  ],
  /*
}, {
  id: 'dungeon-normal',
  type: 'dungeon',
  name: 'Normal',
}, {
  id: 'dungeon-heroic',
  type: 'dungeon',
  name: 'Heroic',
}, {
  id: 'dungeon-mythic',
  type: 'dungeon',
  name: 'Mythic',
  */
}, {
  id: 'dungeon-normal',
  type: 'mplus-chest',
  name: 'Normal',
  quality: 3, // rare
  itemLevel: 158,
  itemLevelOverride: 158,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    7022, // Heroic
    7244, // rare
  ],
}, {
  id: 'dungeon-heroic',
  type: 'mplus-chest',
  name: 'Heroic',
  quality: 3, // rare
  itemLevel: 171,
  itemLevelOverride: 171,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    7022, // Heroic
    7244, // rare
  ],
}, {
  id: 'dungeon-mythic1',
  type: 'mplus-chest',
  name: 'Mythic',
  itemLevel: 184,
  itemLevelOverride: 184,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    7187, // Mythic
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic2',
  type: 'mplus-chest',
  name: 'Mythic 2',
  itemLevel: 187,
  itemLevelOverride: 187,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5440, // Mythic 2
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic3',
  type: 'mplus-chest',
  name: 'Mythic 3',
  itemLevel: 190,
  itemLevelOverride: 190,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5441, // Mythic 3
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic4',
  type: 'mplus-chest',
  name: 'Mythic 4',
  itemLevel: 194,
  itemLevelOverride: 194,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5442, // Mythic 4
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic5',
  type: 'mplus-chest',
  name: 'Mythic 5',
  itemLevel: 194,
  itemLevelOverride: 194,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5443, // Mythic 5
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic6',
  type: 'mplus-chest',
  name: 'Mythic 6',
  itemLevel: 197,
  itemLevelOverride: 197,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5444, // Mythic 6
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic7',
  type: 'mplus-chest',
  name: 'Mythic 7',
  itemLevel: 200,
  itemLevelOverride: 200,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5445, // Mythic 7
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic8',
  type: 'mplus-chest',
  name: 'Mythic 8',
  itemLevel: 200,
  itemLevelOverride: 200,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5446, // Mythic 8
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic9',
  type: 'mplus-chest',
  name: 'Mythic 9',
  itemLevel: 200,
  itemLevelOverride: 200,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5447, // Mythic 9
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic10',
  type: 'mplus-chest',
  name: 'Mythic 10',
  itemLevel: 203,
  itemLevelOverride: 203,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5448, // Mythic 10
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic11',
  type: 'mplus-chest',
  name: 'Mythic 11',
  itemLevel: 203,
  itemLevelOverride: 203,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3509, // Mythic 11
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic12',
  type: 'mplus-chest',
  name: 'Mythic 12',
  itemLevel: 207,
  itemLevelOverride: 207,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3510, // Mythic 12
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic13',
  type: 'mplus-chest',
  name: 'Mythic 13',
  itemLevel: 207,
  itemLevelOverride: 207,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3534, // Mythic 13
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic14',
  type: 'mplus-chest',
  name: 'Mythic 14',
  itemLevel: 207,
  itemLevelOverride: 207,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3535, // Mythic 14
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic15',
  type: 'mplus-chest',
  name: 'Mythic 15',
  itemLevel: 210,
  itemLevelOverride: 210,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3536, // Mythic 15
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic-weekly7',
  type: 'mplus-chest',
  name: '+7 Weekly Chest',
  itemLevel: 213,
  itemLevelOverride: 213,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5445, // Mythic 7
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic-weekly8',
  type: 'mplus-chest',
  name: '+8 Weekly Chest',
  itemLevel: 216,
  itemLevelOverride: 216,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5446, // Mythic 8
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic-weekly10',
  type: 'mplus-chest',
  name: '+10 Weekly Chest',
  itemLevel: 220,
  itemLevelOverride: 220,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5448, // Mythic 10
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic-weekly12',
  type: 'mplus-chest',
  name: '+12 Weekly Chest',
  itemLevel: 223,
  itemLevelOverride: 223,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3510, // Mythic 12
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic-weekly14',
  type: 'mplus-chest',
  name: '+14 Weekly Chest',
  itemLevel: 226,
  itemLevelOverride: 226,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3535, // Mythic 14
    4786, // epic
  ],

}, {

  // PVP VENDORS

  id: 'pvp-honor-shadowlands-season1-rank1',
  type: 'pvp-honor',
  name: 'Rank 1',
  quality: 3,
  itemLevel: 158,
  itemLevelOverride: 158,
  bonusIds: [
    7231, // Rank 1
  ],
}, {
  id: 'pvp-honor-shadowlands-season1-rank2',
  type: 'pvp-honor',
  name: 'Rank 2',
  quality: 3,
  itemLevel: 164,
  itemLevelOverride: 164,
  bonusIds: [
    7232, // Rank 2
  ],
}, {
  id: 'pvp-honor-shadowlands-season1-rank3',
  type: 'pvp-honor',
  name: 'Rank 3',
  quality: 3,
  itemLevel: 171,
  itemLevelOverride: 171,
  bonusIds: [
    7233, // Rank 3
  ],
}, {
  id: 'pvp-honor-shadowlands-season1-rank4',
  type: 'pvp-honor',
  name: 'Rank 4',
  quality: 3,
  itemLevel: 177,
  itemLevelOverride: 177,
  bonusIds: [
    7234, // Rank 4
  ],
}, {
  id: 'pvp-honor-shadowlands-season1-rank5',
  type: 'pvp-honor',
  name: 'Rank 5',
  itemLevel: 184,
  itemLevelOverride: 184,
  bonusIds: [
    7235, // Rank 5
  ],
}, {
  id: 'pvp-honor-shadowlands-season1-rank6',
  type: 'pvp-honor',
  name: 'Rank 6',
  itemLevel: 190,
  itemLevelOverride: 190,
  bonusIds: [
    7236, // Rank 6
  ],
}, {
  id: 'pvp-honor-shadowlands-season1-rank7',
  type: 'pvp-honor',
  name: 'Rank 7',
  itemLevel: 197,
  itemLevelOverride: 197,
  bonusIds: [
    7237, // Rank 7
  ],

}, {
  // Conquest Shadowlands Season 1

  id: 'pvp-conquest-shadowlands-season1-rank1',
  type: 'pvp-conquest',
  name: 'Unranked',
  itemLevel: 200,
  itemLevelOverride: 200,
  bonusIds: [
    7225, // Unranked
  ],
}, {
  id: 'pvp-conquest-shadowlands-season1-rank2',
  type: 'pvp-conquest',
  name: 'Combatant',
  itemLevel: 207,
  itemLevelOverride: 207,
  bonusIds: [
    7226, // Combatant
  ],
}, {
  id: 'pvp-conquest-shadowlands-season1-rank3',
  type: 'pvp-conquest',
  name: 'Challenger',
  itemLevel: 213,
  itemLevelOverride: 213,
  bonusIds: [
    7227, // Challenger
  ],
}, {
  id: 'pvp-conquest-shadowlands-season1-rank4',
  type: 'pvp-conquest',
  name: 'Rival',
  itemLevel: 220,
  itemLevelOverride: 220,
  bonusIds: [
    7228, // Rival
  ],
}, {
  id: 'pvp-conquest-shadowlands-season1-rank5',
  type: 'pvp-conquest',
  name: 'Duelist',
  itemLevel: 226,
  itemLevelOverride: 226,
  bonusIds: [
    7229, // Duelist
  ],
}, {
  id: 'pvp-conquest-shadowlands-season1-rank6',
  type: 'pvp-conquest',
  name: 'Elite',
  itemLevel: '233 Weapons',
  itemLevelOverride: 233,
  bonusIds: [
    7230, // Elite
  ],
  itemFilter: item => {
    // Elite 233 is only for weapons
    const slot = slotMap[item.inventoryType];
    return _.includes(['main_hand', 'off_hand'], slot);
  },
  /*
}, {
  id: 'pvp-conquest-shadowlands-season1-rank6',
  type: 'pvp-conquest',
  name: 'Elite',
  itemLevel: 226,
  itemLevelOverride: 226,
  bonusIds: [
    7230, // Elite
  ],
  */

  /*
}, {

  id: 'azerite-vendor-normal',
  type: 'azerite-vendor',
  name: '445',
  //itemLevel: '165 Titan Residuum',
  itemLevelOverride: 445,
  bonusIds: [
    4786, // epic
    1617, // +160 levels, 445
  ],
}, {
  id: 'azerite-vendor-heroic',
  type: 'azerite-vendor',
  name: '460',
  //itemLevel: '675 Titan Residuum',
  itemLevelOverride: 460,
  bonusIds: [
    4786, // epic
    1632, // +160 levels, 460
  ],
}, {
  id: 'azerite-vendor-mythic',
  type: 'azerite-vendor',
  name: '475',
  itemLevelOverride: 475,
  gambling: {
    buyCost: 20000,
    gambleCost: 4750,
  },
  //itemLevel: '1725 Titan Residuum',
  bonusIds: [
    4786, // epic
    1647, // +160 levels, 475
  ],

}, {

  id: 'benthic-1',
  type: 'benthic',
  name: '385',
  //itemLevel: 'Base',
}, {
  id: 'benthic-2',
  type: 'benthic',
  name: '400',
  //itemLevel: '+20 Manapearls',
  bonusIds: [
    1487, // +15 levels, 400
  ],
}, {
  id: 'benthic-3',
  type: 'benthic',
  name: '405',
  //itemLevel: '+30 Manapearls',
  bonusIds: [
    1492, // +20 levels, 405
  ],
}, {
  id: 'benthic-4',
  type: 'benthic',
  name: '410',
  //itemLevel: '+45 Manapearls',
  bonusIds: [
    1497, // +25 levels, 410
  ],
}, {
  id: 'benthic-5',
  type: 'benthic',
  name: '415',
  //itemLevel: '+70 Manapearls',
  bonusIds: [
    1502, // +30 levels, 415
  ],
}, {
  id: 'benthic-6',
  type: 'benthic',
  name: '420',
  //itemLevel: '+120 Manapearls',
  bonusIds: [
    1507, // +35 levels, 420
  ],
}, {
  id: 'benthic-7',
  type: 'benthic',
  name: '425',
  //itemLevel: '+220 Manapearls',
  bonusIds: [
    1512, // +40 levels, 425
  ],
}, {
  id: 'benthic-8',
  type: 'benthic',
  name: '430',
  //itemLevel: '+220 Manapearls',
  bonusIds: [
    1517, // +45 levels, 430
  ],
  */
}];

export const INSTANCE_OVERRIDES = [{
  // WORLD BOSSES
  instanceId: 1192,
  disableWarforgeLevel: true,
  disableDifficulties: true,
  disableOuterAzeriteRing: true,
  bonusIds: [
    1492, // +20 levels
  ],

  enableSockets: true,
}, {
  // ULDIR
  instanceId: 1031,
  season: 'bfa1',
  disableWarforgeLevel: true,
  disableOuterAzeriteRing: true,
  forceUnlockAzerite: true,

  archive: true,
}, {
  // BATTLE OF DAZAR'ALOR
  instanceId: 1176,
  season: 'bfa2',

  archive: true,
}, {
  // CRUCIBLE OF STORMS
  instanceId: 1177,
  season: 'bfa2',

  archive: true,

  warning: {
    text: 'Crucible of Storms items are difficult to evalaute. Fairly extreme scenarios are simmed by default.',
    link: 'https://medium.com/raidbots/crucible-of-storms-and-other-site-updates-527864de54ec',
  },
}, {
  // ETERNAL PALACE
  instanceId: 1179,
  season: 'bfa3',

  archive: true,
}, {
  // OPERATION: MECHAGON
  instanceId: 1178,
  season: 'bfa3',

  disableDifficulties: true,

  itemLevel: 415,
  archive: true,
}, {
  // MYTHIC+ END OF DUNGEON CHEST
  instanceId: -1,
  season: 'sl1',

  disableAzerite: true,
  showEncounters: true,

  encounterType: 'dungeon',
  encounterTypePlural: 'dungeons',
  encounterAllId: -1,

  enableSockets: true,
  repeatable: true,
}, {
  // AZERITE RESIDUUM VENDOR
  instanceId: -2,
  season: 'bfa4',

  disableWarforgeLevel: true,
  showEncounters: true,

  encounterType: 'container',
  encounterTypePlural: 'containers',
  encounterAllId: -2,
  simAzeriteGear: true,
}, {
  // BENTHIC ITEMS
  instanceId: -3,
  season: 'bfa3',

  disableWarforgeLevel: true,
  showEncounters: false,
  azeriteRequiresPremium: true,

  encounterType: 'container',
  encounterTypePlural: 'containers',
  encounterAllId: -2,
  simAzeriteGear: false,

  enableSockets: true,
  repeatable: true,

  archive: true,
}, {
  // NY'ALOTHA
  instanceId: 1180,
  season: 'bfa4',

  disableWarforgeLevel: true,

  enableSockets: true,
}, {
  // CASTLE NATHRIA
  instanceId: 1190,
  season: 'sl1',

  disableWarforgeLevel: true,

  enableSockets: true,
}, {
  // PVP HONOR VENDOR
  instanceId: -16,
  season: 'sl1',

  disableWarforgeLevel: true,
  showEncounters: false,

  encounterType: 'vendor',
  encounterTypePlural: 'vendors',
  encounterAllId: -14,

  enableSockets: true,
  repeatable: true,
  showChances: false,
}, {
  // PVP CONQUEST VENDOR
  instanceId: -17,
  season: 'sl1',

  disableWarforgeLevel: true,
  showEncounters: false,

  encounterType: 'vendor',
  encounterTypePlural: 'vendors',
  encounterAllId: -15,

  enableSockets: true,
  repeatable: true,

  /*
  warning: {
    text: 'Exact item levels and titles for Conquest gear are not confirmed at this time, Droptimizer is just guessing',
  },
  */
}];

export const SEASONS = {
  sl1: {
    disableWarforgeLevel: true,
  },
  bfa4: {
    disableWarforgeLevel: true,

    azeriteUnlockLevels: [{
      slot: 'head',
      level: 430,
      unlocks: [15, 31, 36, 41, 58],
    }, {
      slot: 'head',
      level: 445,
      unlocks: [15, 31, 36, 41, 63],
    }, {
      slot: 'head',
      level: 460,
      unlocks: [15, 31, 36, 41, 63],
    }, {
      slot: 'head',
      level: 475,
      unlocks: [15, 31, 36, 41, 63],

    }, {

      slot: 'shoulder',
      level: 430,
      unlocks: [15, 33, 38, 43, 60],
    }, {
      slot: 'shoulder',
      level: 445,
      unlocks: [15, 33, 38, 43, 65],
    }, {
      slot: 'shoulder',
      level: 460,
      unlocks: [15, 33, 38, 43, 65],
    }, {
      slot: 'shoulder',
      level: 475,
      unlocks: [15, 33, 38, 43, 65],

    }, {

      slot: 'chest',
      level: 430,
      unlocks: [15, 32, 37, 42, 59],
    }, {
      slot: 'chest',
      level: 445,
      unlocks: [15, 32, 37, 42, 64],
    }, {
      slot: 'chest',
      level: 460,
      unlocks: [15, 32, 37, 42, 64],
    }, {
      slot: 'chest',
      level: 475,
      unlocks: [15, 32, 37, 42, 64],
    }],
  },
  bfa3: {
    warforgeMax: 455,

    azeriteUnlockLevels: [{
      slot: 'head',
      level: 400,
      unlocks: [15, 30, 34, 38, 42],
    }, {
      slot: 'head',
      level: 415,
      unlocks: [15, 31, 36, 41, 46],
    }, {
      slot: 'head',
      level: 430,
      unlocks: [15, 31, 36, 41, 58],
    }, {
      slot: 'head',
      level: 445,
      unlocks: [15, 31, 36, 41, 63],

    }, {

      slot: 'shoulder',
      level: 400,
      unlocks: [15, 32, 36, 40, 44],
    }, {
      slot: 'shoulder',
      level: 415,
      unlocks: [15, 33, 38, 43, 48],
    }, {
      slot: 'shoulder',
      level: 430,
      unlocks: [15, 33, 38, 43, 60],
    }, {
      slot: 'shoulder',
      level: 445,
      unlocks: [15, 33, 38, 43, 65],

    }, {

      slot: 'chest',
      level: 400,
      unlocks: [15, 31, 35, 39, 43],
    }, {
      slot: 'chest',
      level: 415,
      unlocks: [15, 32, 37, 42, 47],
    }, {
      slot: 'chest',
      level: 430,
      unlocks: [15, 32, 37, 42, 59],
    }, {
      slot: 'chest',
      level: 445,
      unlocks: [15, 32, 37, 42, 64],
    }],
  },

  bfa2: {
    warforgeMax: 425,

    azeriteUnlockLevels: [{
      slot: 'head',
      level: 370,
      unlocks: [15, 26, 30, 34, 38],
    }, {
      slot: 'head',
      level: 385,
      unlocks: [15, 29, 32, 35, 38],
    }, {
      slot: 'head',
      level: 400,
      unlocks: [15, 30, 34, 38, 42],
    }, {
      slot: 'head',
      level: 415,
      unlocks: [15, 31, 36, 41, 46],
    }, {
      slot: 'shoulder',
      level: 370,
      unlocks: [15, 28, 32, 36, 40],
    }, {
      slot: 'shoulder',
      level: 385,
      unlocks: [15, 31, 34, 37, 40],
    }, {
      slot: 'shoulder',
      level: 400,
      unlocks: [15, 32, 36, 40, 44],
    }, {
      slot: 'shoulder',
      level: 415,
      unlocks: [15, 33, 38, 43, 48],
    }, {
      slot: 'chest',
      level: 370,
      unlocks: [15, 27, 31, 35, 39],
    }, {
      slot: 'chest',
      level: 385,
      unlocks: [15, 30, 33, 36, 39],
    }, {
      slot: 'chest',
      level: 400,
      unlocks: [15, 31, 35, 39, 43],
    }, {
      slot: 'chest',
      level: 415,
      unlocks: [15, 32, 37, 42, 47],
    }],
  },
};

export const INSTANCE_DIFFICULTY_OVERRIDES = [{

  instanceId: -3,
  difficulty: 'benthic-3',
  disableAzerite: true,
}, {
  instanceId: -3,
  difficulty: 'benthic-4',
  disableAzerite: true,
}, {
  instanceId: -3,
  difficulty: 'benthic-6',
  disableAzerite: true,
}, {
  instanceId: -3,
  difficulty: 'benthic-7',
  disableAzerite: true,
}, {
  instanceId: -3,
  difficulty: 'benthic-8',
  disableNonAzerite: true,

}, {

  // OPERATION: MECHAGON

  instanceId: 1178,
  difficulty: null,
  itemLevel: 415,
  bonusIds: [
    1472, // +0 ilevel
  ],

}, {

  // CASTLE NATHRIA

  instanceId: 1190,
  difficulty: 'raid-lfr',
  itemLevel: '187 - 194',
  itemLevelOverride: 187,
}, {
  instanceId: 1190,
  difficulty: 'raid-normal',
  itemLevel: '200 - 207',
  itemLevelOverride: 200,
}, {
  instanceId: 1190,
  difficulty: 'raid-heroic',
  itemLevel: '213 - 220',
  itemLevelOverride: 213,
}, {
  instanceId: 1190,
  difficulty: 'raid-mythic',
  itemLevel: '226 - 233',
  itemLevelOverride: 226,

}, {

  // NY'ALOTHA

  instanceId: 1180,
  difficulty: 'raid-lfr',
  itemLevel: '430 - 440',
  bonusIds: [
    1472, // +0 ilevel
  ],
}, {
  instanceId: 1180,
  difficulty: 'raid-normal',
  itemLevel: '445 - 455',
  bonusIds: [
    1487, // +15 level
  ],
}, {
  instanceId: 1180,
  difficulty: 'raid-heroic',
  itemLevel: '460 - 470',
  bonusIds: [
    1502, // +30 level
  ],
}, {
  instanceId: 1180,
  difficulty: 'raid-mythic',
  itemLevel: '475 - 485',
  bonusIds: [
    1517, // +45 levels
  ],

}, {

  // ETERNAL PALACE

  instanceId: 1179,
  difficulty: 'raid-lfr',
  itemLevel: 400,
  bonusIds: [
    1472, // +0 ilevel
  ],
}, {
  instanceId: 1179,
  difficulty: 'raid-normal',
  itemLevel: 415,
  bonusIds: [
    1487, // +15 level
  ],
}, {
  instanceId: 1179,
  difficulty: 'raid-heroic',
  itemLevel: 430,
  bonusIds: [
    1502, // +30 level
  ],
}, {
  instanceId: 1179,
  difficulty: 'raid-mythic',
  itemLevel: 445,
  bonusIds: [
    1517, // +45 levels
  ],

}, {

  // CRUCIBLE OF STORMS

  instanceId: 1177,
  difficulty: 'raid-lfr',
  itemLevel: 375,
  bonusIds: [
    1497, // +25 levels
  ],
}, {
  instanceId: 1177,
  difficulty: 'raid-normal',
  itemLevel: 390,
  bonusIds: [
    1512, // +40 level
  ],
}, {
  instanceId: 1177,
  difficulty: 'raid-heroic',
  itemLevel: 405,
  bonusIds: [
    1527, // +55 level
  ],
}, {
  instanceId: 1177,
  difficulty: 'raid-mythic',
  itemLevel: 420,
  bonusIds: [
    1542, // +70 levels
  ],

}, {

  // BATTLE FOR DAZAR'ALOR

  instanceId: 1176,
  difficulty: 'raid-lfr',
  itemLevel: 370,
  bonusIds: [
    1492, // +20 levels
  ],
}, {
  instanceId: 1176,
  difficulty: 'raid-normal',
  itemLevel: 385,
  bonusIds: [
    1507, // +35 level
  ],
}, {
  instanceId: 1176,
  difficulty: 'raid-heroic',
  itemLevel: 400,
  bonusIds: [
    1522, // +50 level
  ],
}, {
  instanceId: 1176,
  difficulty: 'raid-mythic',
  itemLevel: 415,
  bonusIds: [
    1537, // +65 levels
  ],

}, {

  // ULDIR

  instanceId: 1031,
  disableOuterAzeriteRing: true,
  difficulty: 'raid-lfr',
  itemLevel: 340,
  bonusIds: [
    1462, // -10 levels
  ],
}, {
  instanceId: 1031,
  difficulty: 'raid-normal',
  itemLevel: 355,
  disableOuterAzeriteRing: true,
  bonusIds: [
    1477, // +5 level
  ],
}, {
  instanceId: 1031,
  difficulty: 'raid-heroic',
  itemLevel: 370,
  disableOuterAzeriteRing: true,
  bonusIds: [
    1492, // +20 level
  ],
}, {
  instanceId: 1031,
  difficulty: 'raid-mythic',
  itemLevel: 385,
  disableOuterAzeriteRing: true,
  bonusIds: [
    1507, // +35 levels
  ],
}];

const ENCOUNTER_OVERRIDES = [{

  ///////////////////////////////////////////////
  // CASTLE NATHRIA

  // STONE LEGION GENERALS

  encounterId: 2425,
  difficulty: 'raid-lfr',
  itemLevel: 194,
  itemLevelOverride: 194,
}, {
  encounterId: 2425,
  difficulty: 'raid-normal',
  itemLevel: 207,
  itemLevelOverride: 207,
}, {
  encounterId: 2425,
  difficulty: 'raid-heroic',
  itemLevel: 220,
  itemLevelOverride: 220,
}, {
  encounterId: 2425,
  difficulty: 'raid-mythic',
  itemLevel: 233,
  itemLevelOverride: 233,
}, {

  // SIRE DENATHRIUS
  encounterId: 2424,
  difficulty: 'raid-lfr',
  itemLevel: 194,
  itemLevelOverride: 194,
}, {
  encounterId: 2424,
  difficulty: 'raid-normal',
  itemLevel: 207,
  itemLevelOverride: 207,
}, {
  encounterId: 2424,
  difficulty: 'raid-heroic',
  itemLevel: 220,
  itemLevelOverride: 220,
}, {
  encounterId: 2424,
  difficulty: 'raid-mythic',
  itemLevel: 233,
  itemLevelOverride: 233,
}, {

  ///////////////////////////////////////////////
  // WORLD BOSSES

  // World Boss - Lion's Roar
  encounterId: 2212,
  bonusIds: [
    1492, // +20 level
  ],
}, {
  // World Boss - Doom's Howl
  encounterId: 2213,
  bonusIds: [
    1492, // +20 level
  ],
}, {
  // World Boss - Ivus the Forest Lord
  encounterId: 2329,
  bonusIds: [
    5479, // Ivus "Heroic" tag
    // updated from +30 to +45 for season 2
    1517, // +45 level
  ],
  disableOuterAzeriteRing: false,
}, {
  // World Boss - Ivus the Decayed
  encounterId: 2345,
  bonusIds: [
    5479, // Ivus "Heroic" tag
    // updated from +30 to +45 for season 2
    1517, // +45 level
  ],
  disableOuterAzeriteRing: false,
}, {
  // World Boss - Ulmath, the Soulbinder
  encounterId: 2362,
  bonusIds: [
    1487, // +15 level
  ],
  disableOuterAzeriteRing: false,
}, {
  // World Boss - Wekemara
  encounterId: 2363,
  bonusIds: [
    1487, // +15 level
  ],
  disableOuterAzeriteRing: false,
}, {
  // 8.3 world boss: Grand Empress Shek'zara
  encounterId: 2378,
  itemLevelOverride: 445,
  disableOuterAzeriteRing: false,
}, {
  // 8.3 world boss: Vuk'laz the Earthbreaker
  encounterId: 2381,
  itemLevelOverride: 445,
  disableOuterAzeriteRing: false,

}, {

  // CRUCIBLE OF STORMS - UUNAT +5 ILEVEL

  // UUNAT LFR
  encounterId: 2332,
  difficulty: 'raid-lfr',
  itemLevel: 380,
  bonusIds: [
    1502, // +30 levels
  ],
}, {

  // UUNAT NORMAL
  encounterId: 2332,
  difficulty: 'raid-normal',
  itemLevel: 395,
  bonusIds: [
    1517, // +45 level
  ],
}, {

  // UUNAT HEROIC
  encounterId: 2332,
  difficulty: 'raid-heroic',
  itemLevel: 410,
  bonusIds: [
    1532, // +60 level
  ],
}, {

  // UUNAT MYTHIC
  encounterId: 2332,
  difficulty: 'raid-mythic',
  itemLevel: 425,
  bonusIds: [
    1547, // +70 levels
  ],
}];

const getInstance = instanceId => _.find(Instances, { id: instanceId });
const getEncounter = encounterId => _.find(Encounters, { id: encounterId });
const getDifficulty = difficultyId => _.find(DIFFICULTIES, { id: difficultyId });
const getSeason = seasonId => SEASONS[seasonId];

const getEncounterOverrides = (instanceId, encounterId, difficultyId) => {
  const difficulty = getDifficulty(difficultyId);

  // instance + encounter
  let encounterOverrides;
  if (difficultyId) {
    encounterOverrides = _.find(
      ENCOUNTER_OVERRIDES,
      {
        encounterId,
        difficulty: difficultyId,
      },
    );
  } else {
    encounterOverrides = _.find(
      ENCOUNTER_OVERRIDES,
      {
        encounterId,
      },
    );
  }

  // instance + difficulty
  const instanceDifficultyOverrides = _.find(
    INSTANCE_DIFFICULTY_OVERRIDES,
    {
      instanceId,
      difficulty: difficultyId,
    },
  );

  // general instance overrides
  const instanceOverrides = _.find(
    INSTANCE_OVERRIDES,
    {
      instanceId,
    },
  );

  const instance = getInstance(instanceId);
  const encounter = getEncounter(encounterId);

  let season;
  if (instanceOverrides) {
    season = getSeason(instanceOverrides.season);
  }

  const overrides = {};

  _.defaults(
    overrides,
    season,
    encounterOverrides,
    instanceDifficultyOverrides,
    instanceOverrides,
    {
      instance,
      encounter,
      difficulty,
      encounterType: 'boss',
      encounterTypePlural: 'bosses',
      quality: difficulty?.quality ?? 4,

      // add some difficulty options at the top level (but not everything)
      // (Not sure why not everything, need to spend some more time remembering why it wrote it that way)
      itemLevel: _.get(difficulty, 'itemLevel'),
      itemLevelOverride: _.get(difficulty, 'itemLevelOverride'),
      gambling: _.get(difficulty, 'gambling'),
      itemFilter: _.get(difficulty, 'itemFilter'),
    },
  );

  return overrides;
};

const getItems = ({
  instance,
  encounter,
  instances, // legacy
  encounters, // legacy
  difficulty,
  warforgeLevel,
  gem,
  classId,
  specId,
  lootSpecId,
  faction,
  covenant,
  // Use static data by default, but allow overrides.
  // This lets reports save a snapshot of the item/instance list from sim time so that
  // things don't break as Droptimizer updates are made.
  // Also means Droptimizer data doesn't need to be loaded on a report page.
  itemLibrary = EncounterItems,
  instanceLibrary = Instances,
}) => {
  if (!itemLibrary && !loaded) {
    // eslint-disable-next-line
    console.warn('Droptimizer is not ready, must call loadStaticData() with proper data');
    return [];
  }

  const selectedInstanceId = instance || _.first(instances);
  const selectedEncounterId = instance ? encounter : _.first(encounters);

  const baseItems = _.map(
    _.filter(itemLibrary, item => {
      if (!_.includes(_.map(item.sources, 'instanceId'), selectedInstanceId)) {
        return false;
      }
      // if loot spec available, use that. Otherwise fall back to current spec ID

      if (!doesItemDrop(item, classId, lootSpecId || specId)) {
        return false;
      }
      if (item.faction && item.faction !== faction) {
        return false;
      }
      if (item.covenant && covenant && item.covenant !== covenant) {
        return false;
      }

      const encounterId = _.first(item.sources).encounterId;

      const overrides = getEncounterOverrides(selectedInstanceId, selectedEncounterId || encounterId, difficulty);
      if (overrides.disabled) {
        return false;
      }
      if (overrides.disableAzerite && item.azeritePowerSetId) {
        return false;
      }
      if (overrides.disableNonAzerite && !item.azeritePowerSetId) {
        return false;
      }

      const checkEncounterId = selectedEncounterId && selectedEncounterId !== -1;
      if (checkEncounterId && selectedEncounterId !== encounterId) {
        return false;
      }

      if (overrides.itemFilter) {
        return overrides.itemFilter(item);
      }

      return true;
    }),
  );

  // expand tokens into possible drops
  const expandedItems = [];
  _.each(baseItems, item => {
    if (item.contains) {
      _.each(item.contains, itemId => {
        const it = _.find(itemLibrary, { id: itemId });
        if (it) {
          if (doesItemDrop(it, classId, lootSpecId || specId)) {
            let valid = true;

            // I AM HERE
            // keep testing droptimizer
            //  - old reports - how does it work
            //  - report isn't showing new weapons correctly
            // handle token expansion in top gear
            // test with simc input

            // double check covenant here
            if (it.covenant && covenant && it.covenant !== covenant) {
              valid = false;
            }

            if (valid) {
              expandedItems.push({
                ...it,
                // copy sources from the token
                sources: item.sources,
              });
            }
          }
        }
      });
    } else {
      expandedItems.push({ ...item });
    }
  });

  const items = _.sortBy(
    _.map(
      expandedItems,
      item => {
        const slot = slotMap[item.inventoryType];

        const instanceId = selectedInstanceId || _.first(item.sources).instanceId;
        const encounterId = selectedEncounterId || _.first(item.sources).encounterId;

        const overrides = getEncounterOverrides(instanceId, encounterId, difficulty);

        let addSocket = false;
        if (overrides.enableSockets && gem && !warforgeLevel && canRollSocket(item)) {
          addSocket = true;
        }

        let baseBonusIds = item.bonusLists;
        if (!overrides.disableDifficulties) {
          baseBonusIds = _.union(baseBonusIds, _.get(_.find(DIFFICULTIES, { id: difficulty }), 'bonusIds', []));
        }

        const instanceBonusIds = _.get(overrides, 'bonusIds', []);

        const isWeapon = _.includes(['main_hand', 'off_hand'], slot);
        const isAzerite = Boolean(item.azeritePowerSetId);
        let bonusIds = _.flatten(
          _.map(
            _.union(baseBonusIds, instanceBonusIds),
            bonusId => {
              // adjust level bonus ID to handle warforge level offset
              const isLevelBonus = _.isNumber(GameData.BonusLevels[String(bonusId)]);
              if (warforgeLevel && isLevelBonus && !isAzerite) {
                let amount = isWeapon ? _.min([warforgeLevel, 10]) : warforgeLevel;

                const newItemLevel = overrides.itemLevel + amount;
                if (newItemLevel > overrides.warforgeMax) {
                  amount -= newItemLevel - overrides.warforgeMax;
                }

                let warforgeBonusId = null;
                if (amount > 10) {
                  warforgeBonusId = TITANFORGED_BONUS_ID;
                } else if (amount > 0) {
                  warforgeBonusId = WARFORGED_BONUS_ID;
                }
                return _.filter([bonusId + amount, warforgeBonusId]);
              }
              return bonusId;
            },
          ),
        );

        // only keep last level offset bonus ID
        bonusIds = _.union(
          // get all non-level-offset bonus IDs
          _.reject(bonusIds, id => GameData.BonusLevels[String(id)]),
          [_.last(_.filter(bonusIds, id => GameData.BonusLevels[String(id)]))],
        );

        const levelOffset = _.last(
          _.filter(
            _.map(bonusIds, id => GameData.BonusLevels[String(id)]),
          ),
        ) || 0;

        if (addSocket) {
          bonusIds.push(_.first(socketBonuses));
        }

        let itemLevel = item.itemLevel + levelOffset;

        if (overrides.itemLevelOverride && itemLevel !== overrides.itemLevelOverride) {
          // modify item level bonus
          const offBy = overrides.itemLevelOverride - itemLevel;
          const currentLevelBonusId = _.last(_.filter(bonusIds, id => GameData.BonusLevels[String(id)])) || 1472;
          bonusIds = _.without(bonusIds, currentLevelBonusId);
          bonusIds.push(currentLevelBonusId + offBy);
          itemLevel = overrides.itemLevelOverride;
        }

        return {
          ...item,
          quality: overrides.quality ?? 4, // default to epic
          itemLevel,
          bonus_id: _.compact(_.union(bonusIds)).join('/'),
          gem_id: addSocket ? gem : undefined,
          instanceId,
          encounterId,
          difficulty,
          instance: overrides.instance,
          encounter: overrides.encounter,
          sources: _.filter(item.sources, source => {
            const sourceEncounters = _.flatten(_.map(instanceLibrary, 'encounters'));
            const sourceEncounter = _.find(sourceEncounters, { id: source.encounterId });
            if (!sourceEncounter) {
              return false;
            }
            if (sourceEncounter.faction && sourceEncounter.faction !== faction) {
              return false;
            }
            return true;
          }),
          overrides,
        };
      },
    ),
    ['itemLevel', 'inventoryType'],
  );

  return items;
};

// This is probably OK to naively memoize. Finite number of variations though it may be large
const getVariations = _.memoize(({
  instance,
  encounter,
  instances,
  encounters,
  difficulty,
  warforgeLevel,
  gem,
  classId,
  specId,
  lootSpecId,
  faction,
  equipped,
  mainHandAlternateWeapon,
  offHandAlternateWeapon,
  simAzeriteGear = true,
  azeriteLevel,
  allAzeritePowers = true,
  covenant,
  itemLibrary,
  instanceLibrary,
}) => {
  if (!itemLibrary && !loaded) {
    // eslint-disable-next-line
    console.warn('Droptimizer is not ready, must call loadStaticData() with proper data');
    return [];
  }
  const items = getItems({
    instance,
    encounter,
    instances,
    encounters,
    difficulty,
    warforgeLevel,
    gem,
    classId,
    specId,
    lootSpecId,
    faction,
    azeriteLevel,
    allAzeritePowers,
    covenant,
    itemLibrary,
    instanceLibrary,
  });

  const overrides = getEncounterOverrides(instance, encounter, difficulty);

  if (!equipped || _.size(equipped) === 0) {
    return null;
  }

  const specInfo = getSpecInfo(classId, specId);

  const variations = [];

  const equippedMainHands = getWeaponHands(equipped.mainHand);

  const hasAlternateWeapons = mainHandAlternateWeapon && offHandAlternateWeapon;

  // generate all variations for the raw item list
  _.each(items, origItem => {
    const item = { ...origItem };

    // figure out slots
    const slots = [];
    const rawSlot = slotMap[item.inventoryType];
    if (_.includes(['finger', 'trinket'], rawSlot)) {
      const doubleSlots = [1, 2];
      _.each(doubleSlots, slotNum => {
        const testSlot = `${rawSlot}${slotNum}`;
        const otherSlotNum = _.first(_.xor(doubleSlots, [slotNum]));
        const otherSlot = `${rawSlot}${otherSlotNum}`;
        // generalize for item categories / item limits
        if (!item.uniqueEquipped || _.get(equipped[otherSlot], 'id') !== _.get(item, 'id')) {
          slots.push({ slot: testSlot });
        }
      });
    } else if (rawSlot === 'main_hand') {
      // weapon permutations
      const hands = getWeaponHands(item);
      // 1. Handle dual wield scenarios
      //    a. Caveat for specs that use 2h or dual-wield 1h - currently just match what's in their hands
      const dualWield1h = equippedMainHands === '1h' && hands === '1h' && specInfo.dualWield;
      const dualWield2h = equippedMainHands === '2h' && hands === '2h' && specInfo.dualWield2h;
      if (dualWield1h || dualWield2h) {
        const testSlots = ['main_hand', 'off_hand'];
        _.each(testSlots, testSlot => {
          const otherSlot = _.camelCase(_.first(_.xor(testSlots, testSlot)));
          if (!item.uniqueEquipped || item.id !== _.get(equipped[otherSlot], 'id')) {
            slots.push({ slot: testSlot });
          }
        });
      } else if (equippedMainHands === '2h' && (hands === '1h' || hands === 'mh')) {
        // . Casters can handle 2h staff or MH/OH if alternates are set up from /simc input
        if (offHandAlternateWeapon) {
          slots.push({
            slot: rawSlot,
            alternate: {
              ...offHandAlternateWeapon,
              ilevel: offHandAlternateWeapon.itemLevel,
              bonus_id: _.join(offHandAlternateWeapon.bonusLists, '/'),
            },
            alternateSlot: 'off_hand',
          });
        }
      } else {
        // simple case (no dual-wield, no caster shenanigans), just add the item
        slots.push({ slot: rawSlot });
      }
    } else if (rawSlot === 'off_hand') {
      if (equippedMainHands !== '2h') {
        slots.push({ slot: rawSlot });
      } else if (equippedMainHands === '2h' && hasAlternateWeapons) {
        // could this go screwy for WW monk / frost DK?
        slots.push({
          slot: rawSlot,
          alternate: {
            ...mainHandAlternateWeapon,
            ilevel: mainHandAlternateWeapon.itemLevel,
            enchant_id: _.get(equipped, 'mainHand.tooltipParams.enchant'),
            bonus_id: _.join(mainHandAlternateWeapon.bonusLists, '/'),
          },
          alternateSlot: 'main_hand',
        });
      }
    } else {
      slots.push({ slot: rawSlot });
    }

    _.each(slots, ({ slot, alternate, alternateSlot }) => {
      const slotItem = { ...item };
      const equippedItem = equipped[_.camelCase(slot)];

      let equippedSameOrBetter = false;
      const sameItemIdEquipped = _.get(item, 'id') === _.get(equippedItem, 'id');
      const equippedHasGem = Boolean(_.get(equippedItem, 'tooltipParams.gem0'));
      const potentialHasGem = Boolean(item.gem_id);
      if (sameItemIdEquipped) {
        if (equippedItem.itemLevel >= item.itemLevel) {
          // equipped gem, potential gem = skip potential
          // equipped no gem, potential no gem = skip potential
          // equipped gem, potential no gem = skip potential
          // equipped no gem, potential gem = sim potential
          if (potentialHasGem && !equippedHasGem) {
            // allow this option to be simmed
          } else {
            equippedSameOrBetter = true;
          }
        }
      }

      const enchant = _.get(equippedItem, 'tooltipParams.enchant') || 0;
      _.set(slotItem, 'enchant_id', enchant);
      _.set(slotItem, 'tooltipParams.enchant', enchant);

      const nameParts = [
        slotItem.instanceId,
        slotItem.encounterId,
        slotItem.difficulty,
        slotItem.id,
        enchant,
        slot,
      ];

      const baseVariation = {
        id: _.join(nameParts, '/'),
        slot,
        item: slotItem,
        equippedSameOrBetter,
      };

      if (slotItem.azeriteTiers) {
        if (simAzeriteGear || overrides.simAzeriteGear) {
          const powerCombos = Combinatorics.cartesianProduct(...slotItem.azeriteTiers).toArray();
          _.each(powerCombos, powerCombo => {
            const powerList = _.map(powerCombo, 'id');
            variations.push({
              ...baseVariation,
              id: _.join([...nameParts, _.join(powerList, '-')], '/'),
              item: {
                ...slotItem,
                azerite_powers: _.join(powerList, '/'),
              },
            });
          });
        }
      } else {
        variations.push({
          ...baseVariation,
          alternate: _.clone(alternate),
          alternateSlot,
        });
      }
    });
  });

  return variations;
});

const shouldCalcRolls = ({ /*gem,*/ warforgeLevel }) => {
  /*
  if (gem) {
    return false;
  }
  */
  if (warforgeLevel > 0) {
    return false;
  }
  return true;
};

export default {
  ready: () => loaded,
  loadStaticData,

  getItems,
  getVariations,
  getInstance,
  getEncounter,
  getEncounterOverrides,
  getDifficulty,

  shouldCalcRolls,

  getEncounters: () => Encounters,
  getInstances: () => Instances,
};
